import React, { useState, useRef } from "react";
import classNames from "classnames";
import Modal from 'react-modal';

const Video = ({closeVideo}) => {
  const body = document.getElementsByTagName("body")[0];
  const [played, setPlayed] = useState(true)
  const player = useRef(null)

  const videoClass = () => {
    return classNames(
      "full-screen-video",
      { played: played}
    )
  }

  const handleClick = () => {
    setPlayed(!played)
  }

  const playVideo = () => {
    handleClick()
    player.current.play()
  }

  return(
    <Modal
      isOpen
      appElement={body}
      shouldCloseOnOverlayClick={false}
      className="modal fade in help-dialog">
          
      <div className={videoClass()}>
        <button className="close" onClick={closeVideo}>
          <span>×</span>
        </button>
        <video ref={player} autoPlay controls height="100%" onClick={handleClick}>
          <source src="https://139824.selcdn.ru/video/email-builder.mp4" type="video/mp4" />
        </video>
        <div className="btn-play" onClick={playVideo}>
          <i className="fa fa-play"></i>
        </div>
      </div>

    </Modal>
  )
}

export default Video
